import React from 'react';
import { Helmet } from 'react-helmet-async';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';

import RecurrenceContent from './Content/Content';

const Recurrence = () => (
  <StarsWizard.Page name="Recurrence">
    <Helmet>
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@300;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>
    <RecurrenceContent />
  </StarsWizard.Page>
);

Recurrence.displayName = 'Recurrence';

export default Recurrence;
